<!-- <wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px"> -->
  <wiz-vgroup width="100%" height="100%" class="section-container">
  
    <wiz-hgroup  width="100%">
      <wiz-label [wizLabel]="title" class="smallTitleLabel" width="100%"></wiz-label>
      <wiz-icon  style="cursor: pointer;" class="image-purple"  [wizTooltip]="'$.common.close.$'"  (click)="doHide()">close</wiz-icon>
    </wiz-hgroup>
    <wiz-list
      #lstData
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      [wizDataProvider]="messDS"
      id="lstData"></wiz-list>
  </wiz-vgroup>
